module.exports = __webpack_public_path__ + "media/entities/5102-b37bdceb.png";